import './ConnectMarketplaceDashboard.scss';
import { DateTimeHelper } from '../../utils/dateTimeHelper';
import { isViewAsBuyerActive } from '../../utils/viewAsBuyer';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { paths } from '../../routing/path';
import { Alert, Breadcrumb, BreadcrumbItem, Button, Card } from 'reactstrap';
import { HomeButton } from '../../components/HomeButton/home-button';
import Layout from '../../components/Layout';
import { Tooltip } from 'react-tooltip';
import { createPortal } from 'react-dom';
import MyEngagement from './MyEngagement/MyEngagement';
import { useStateSelector } from '../../store/selectors';
import { UpdateLastActiveEngagement } from '../../slices/user-summary/update-last-active-engagement.thunk';
import Helpers from '../../utils/helper';
import EngagementBuyers, { formatBuyerDisplayName } from './Buyers/EngagementBuyers';
import { useDispatch } from 'react-redux';
import vvConnectLogo from '../../assets/demo-ui/images/VetValueConnect.png';
import {
    SellerMarketplaceTab,
    SellerMarketplaceTabs,
} from '../../slices/marketplace/timeline/models/enums/seller-marketplace-tab.enum';
import EngagementTimeline from './EngagementTimeline/EngagementTimeline';
import {
    findBuyerDdNdaDocument,
    isDdNdaDocumentSignedByBuyer,
} from './EventActionAvailabilityHelper';
import { ActionDocumentType } from '../../slices/marketplace/timeline/models/enums/action-document-type.enum';
import { DocumentDetailsStatus } from '../../slices/marketplace/timeline/models/enums/document-details-status.enum';
import {
    BuyerSelectionOptionsList,
    NdaTermSelectionOptionsList,
    TimelineActionType,
} from '../../slices/marketplace/timeline/models/timeline-action-type.model';
import SellersEngagementDocuments from './EngagementDocuments/SellersEngagementDocuments/SellersEngagementDocuments';
import NdaTermsPopup from './NdaTermsPopup/NdaTermsPopup';
import NoPageAccessAlert from '../../components/NoPageAccessAlert/NoPageAccessAlert';
import ContactSupportButton from '../ContactSupportButton/ContactSupportButton';
import { SupportContextEnum } from '../../support-portal/models/SupportContext';
import TeaserInfoModal from '../AdminMarketplace/TeaserInfoModal/TeaserInfoModal';
import BuyerSelectionPopup from './BuyerSelectionPopup/BuyerSelectionPopup';
import DeadlineDocket from './DeadlineDocket/DeadlineDocket';
import { DataAndDocsTab } from './DataAndDocsTab/DataAndDocsTab';
import { TimelineEventStatus } from '../../slices/marketplace/timeline/models/enums/timeline-event-status.enum';
import { EngagementProcessStatus } from '../../slices/marketplace/timeline/models/enums/engagement-process-status.enum';
import { anyLoiSelected } from '../../slices/marketplace/timeline/models/engagement-process.model';
import { TimelineEvent } from '../../slices/marketplace/timeline/models/timeline-event.model';
import { TimelineTempo } from '../../slices/marketplace/timeline/models/enums/timeline-tempo.enum';
import { TimelineEventSortingService } from '../AdminMarketplace/TimelinePage/TimelineEventSortingService';
import MarketplaceSettings from '../AdminMarketplace/MarketplaceTabs/MarketplaceSettings/MarketplaceSettings';
import { GetTimelineById } from '../../slices/marketplace/timeline/thunks/get-timeline-by-id.thunk';
import { GetBuyerTimeline } from '../../slices/marketplace/timeline/thunks/get-buyer-timeline.thunk';
import { resetCurrentTimeline, resetDrilledTimeline } from '../../slices/marketplace/timeline/timeline.slice';
import { TimelineState } from '../../slices/marketplace/timeline/models/enums/timeline-state.enum';
import {
    isTheResumeCatchUp,
    documentsToApproveAgainOn,
    isWaitingForTheCatchUp,
    openTeaserApprovalOf,
    withOnlyTheRiders,
    withoutTheRiders,
} from '../../slices/marketplace/timeline/utils/catch-up-wait';
import { CatchUpBanner } from './CatchUpBanner/CatchUpBanner';
import { GetResumeCatchUp } from '../../slices/marketplace/timeline/thunks/get-resume-catch-up.thunk';
import { Timeline } from '../../slices/marketplace/timeline/models/timeline.model';
import { catchUpOrdinalOf, formatCatchUpName, ridersOf } from '../../slices/marketplace/timeline/utils/catch-up-naming';
import { GetEngagementTimelines } from '../../slices/marketplace/timeline/thunks/get-engagement-timelines.thunk';
import { TimelineKind } from '../../slices/marketplace/timeline/models/enums/timeline-kind.enum';
import { CatchUpPurpose } from '../../slices/marketplace/timeline/models/enums/catch-up-purpose.enum';
import { MarketplaceCommsHub } from '../AdminMarketplace/MarketplaceTabs/MarketplaceCommsHub/MarketplaceCommsHub';
import { PaymentValidator } from './PaymentValidator/PaymentValidator';
import { LoadMarketplacePricing } from '../../slices/marketplace/pricing/load-marketplace-pricing.thunk';
import EngagementHistoryTable from '../../components/EngagementHistoryTable/EngagementHistoryTable';
import { TimelineParty } from '../../slices/marketplace/timeline/models/enums/timeline-party.enum';
import ValueRangeModal from '../Admin/BuyerMarketplace/ValueRangeModal/ValueRangeModal';
import {
    getMarketplaceCommsHubTabs,
    MarketplaceCommsHubTab,
    MarketplaceCommsHubMeetingsTab,
} from '../AdminMarketplace/MarketplaceTabs/MarketplaceCommsHub/MarketplaceCommsHubTabs';
import { useHasMeetingsOrClips } from '../../custom-hooks/useHasMeetingsOrClips';
import { useClearNotificationFlagsOnLeave } from '../../custom-hooks/useClearNotificationFlagsOnLeave';
import { useCurrentMarketplaceParty } from '../../custom-hooks/useCurrentMarketplaceParty';
import { useViewedTimelineId } from '../../custom-hooks/useViewedTimelineId';
import { NOT_ENGAGED_BUYER_QUERY_PARAM, TIMELINE_QUERY_PARAM } from '../../notifications/viewed-timeline';
import { NotificationFlag } from '../../components/NotificationFlag/NotificationFlag';
import { NotificationFlagsCategories } from '../../models/NotificationFlags/NotificationFlagsCategories';
import { marketplaceFlagCodes } from '../../notifications/notification-flag-codes';
import { RefreshNotificationFlags } from '../../slices/notification-flags/refresh-notification-flags';
import { SelectProfile } from '../../slices/profiles-data-slice/thunks/select-profile.thunk';
import { RefreshProfile } from '../../slices/profiles-data-slice/thunks/refresh-profile.thunk';
import { useSignalR } from '../../context/WebsocketProvider';
import { EngagementBuyer } from '../../slices/marketplace/timeline/models/engagement-buyer.model';
import { MarketplaceBuyer } from '../../slices/marketplace/buyer/models/buyer';
import { MarketplaceSellerProfileComponent } from '../../components/MarketplaceSellerProfile/MarketplaceSellerProfileComponent';
import VDRAccess from './VDRAccess/VDRAccess';
import EngagementDataRoomHost from './EngagementDataRoomHost/EngagementDataRoomHost';
import { USER_ROLES } from '../../utils/constants';
import {
    MARKETPLACE_SELLER_TEAM_MEMBER_PERMISSION,
    SELLER_TM_ROLE,
} from '../../utils/associateMembersConstants';
import { LoiFormsTab } from './LoiFormsTab/LoiFormsTab';
import { MarketplaceFaqs } from '../AdminMarketplace/MarketplaceTabs/AdminFaqs/AdminFaqs';
import { LoiComparisonTab } from './LoiComparisonTab/LoiComparisonTab';
import {
    LogMarketplaceActivityRequest,
    MarketplaceActivityEvent,
} from './marketplace-activity-audit-log.model';
import { FlowOfFundsTab } from './FlowOfFundsTab/FlowOfFundsTab';
import { isFlowOfFundsAvailable } from '../../utils/flowOfFundsAccess';
import {
    canAdminEditDuringSuspension,
    canSellerEditDuringSuspension,
} from '../../utils/daqiEditAccess';
import { groupDividerClass } from '../../utils/tabGroupDividers';

const toTwoLineTabLabel = (label: string): string => {
    const words = label.split(' ');
    if (words.length < 3) return label;
    let breakIndex = 1;
    let longestLine = Infinity;
    for (let i = 1; i < words.length; i++) {
        const line = Math.max(
            words.slice(0, i).join(' ').length,
            words.slice(i).join(' ').length
        );
        if (line < longestLine) {
            longestLine = line;
            breakIndex = i;
        }
    }
    return (
        words.slice(0, breakIndex).join('\u00a0') +
        ' ' +
        words.slice(breakIndex).join('\u00a0')
    );
};

const ConnectMarketplaceDashboard = () => {
    const connection = useSignalR().connection;
    const isConnected = useSignalR().isConnected;

    const axios = useStateSelector((t) => t.core.axios);
    const navigate = useNavigate();
    const dispatch = useDispatch() as any;

    const summary = useStateSelector((state) => state.userSummary.summary);
    const currentUser = useStateSelector((state) => state.currentUser.user);
    const currentEngagement = useStateSelector(
        (state) => state.timelines.currentTimeline
    );
    const drilledTimeline = useStateSelector(
        (state) => state.timelines.drilledTimeline
    );
    const engagementTimelines = useStateSelector(
        (state) => state.timelines.engagementTimelines
    );

    const [searchParams, setSearchParams] = useSearchParams({});
    const mainTimelineId = currentEngagement?.timelineId ?? currentEngagement?.id;
    const viewedTimelineId = useViewedTimelineId(mainTimelineId);
    const isDrilledDown =
        !!currentEngagement &&
        viewedTimelineId !== undefined &&
        viewedTimelineId !== mainTimelineId;
    const shownTimeline = isDrilledDown ? drilledTimeline : currentEngagement;
    // [#1299] The Seller acts on the resume's catch-up in its own schedule; their own timeline waits, not acted on.
    const isOnTheCatchUp = isDrilledDown && isTheResumeCatchUp(drilledTimeline);
    const isTheSellersTimelineWaiting = !isDrilledDown && isWaitingForTheCatchUp(currentEngagement);
    const isDrilledIntoACatchUp =
        isDrilledDown && drilledTimeline?.kind === TimelineKind.CATCH_UP_MASTER;
    const isALateBuyersCatchUp =
        isDrilledIntoACatchUp &&
        engagementTimelines.find((summary) => summary.timelineId === drilledTimeline?.timelineId)
            ?.catchUpPurpose === CatchUpPurpose.LATE_BUYER;
    const lastLoggedTabRef = useRef<number | null>(null);
    const engagementId = Number(useParams().engagementId);

    const party = useCurrentMarketplaceParty(engagementId);
    const hasMeetingsOrClips = useHasMeetingsOrClips(engagementId);

    const isAdmin = party === TimelineParty.VetValue;
    const isBroker = party === TimelineParty.Broker;
    const isObserver = party === TimelineParty.Observer;

    const isLoiSelectionFinalized =
        currentEngagement?.events?.find(
            (e) => e.linkedAction?.actionType === TimelineActionType.SellerLoiComparison
        )?.linkedAction?.isSelectionFinalized === true;

    const [isNdaTermPopupVisible, setIsNdaTermPopupVisible] = useState(false);
    const [isBuyerSelectionPopupVisible, setIsBuyerSelectionPopupVisible] =
        useState(false);
    const [isTeaserInfoModalVisible, setIsTeaserInfoModalVisible] =
        useState(false);
    const [resumeCatchUp, setResumeCatchUp] = useState<Timeline | null>(null);

    const [systemBuyers, setSystemBuyers] = useState<MarketplaceBuyer[]>([]);

    const [activeEventId, setActiveEventId] = useState<string>('');

    const [activeTab, setActiveTab] = useState<number>(
        SellerMarketplaceTab.MyEngagement
    );
    const [highlightItemId, setHighlightItemId] = useState('');
    const [documentIdToSign, setDocumentIdToSign] = useState<string | null>(
        null
    );
    const [isRangeOfValueVisible, setIsRangeOfValueVisible] = useState(false);
    const [buyerValueRangeInterest, setBuyerValueRangeInterest] = useState<{
        minValue: number;
        maxValue: number;
    } | null>(null);

    const [isEngagementLoading, setIsEngagementLoading] =
        useState<boolean>(true);
    const [isSystemBuyersLoading, setIsSystemBuyersLoading] =
        useState<boolean>(true);

    const [events, setEvents] = useState<TimelineEvent[]>([]);
    const [
        engagementHistoryRefreshTrigger,
        setEngagementHistoryRefreshTrigger,
    ] = useState(false);

    const [availableBuyers, setAvailableBuyers] = useState<EngagementBuyer[]>(
        []
    );

    const [
        isPracticeOfCurrentUserAndIsInEngagement,
        setIsPracticeOfCurrentUserAndIsInEngagement,
    ] = useState<boolean>(false);

    const isEngagementActive = () => {
        if (!currentEngagement || !currentEngagement?.engagementProcess) {
            return false;
        }
        const status = currentEngagement?.engagementProcess?.status;
        return status === EngagementProcessStatus.Current;
    };

    const isTeamMemberWithReadonlyAccess = () => {
        var isTeamMemberWithReadonlyAccess =
            summary?.roleId == USER_ROLES.PRACTICE_SECONDARY_USER &&
            ((summary?.associateMember ?? []) as any[]).some(
                (am) =>
                    am.associateMemberMarketplaceMappings &&
                    (am.associateMemberMarketplaceMappings as any[]).some(
                        (mapping) =>
                            mapping.isSellerSide &&
                            mapping.engagementId == engagementId
                    )
            );

        return isTeamMemberWithReadonlyAccess;
    };

    const getSellerTMCurrentPermissions = (): number[] => {
        if (summary?.roleId !== USER_ROLES.PRACTICE_SECONDARY_USER) return [];
        for (const am of (summary?.associateMember ?? []) as any[]) {
            if (!am.associateMemberMarketplaceMappings) continue;
            for (const mapping of am.associateMemberMarketplaceMappings) {
                if (
                    mapping.isSellerSide &&
                    mapping.engagementId == engagementId &&
                    mapping.currentSellerTMPermissions?.length > 0
                ) {
                    return (mapping.currentSellerTMPermissions as any[]).map(
                        Number
                    );
                }
            }
        }
        return [];
    };

    const isSellerTMLegalCounsel = (): boolean => {
        if (summary.roleId !== USER_ROLES.PRACTICE_SECONDARY_USER) return false;
        return (summary.associateMember as any[]).some((am) =>
            am.associateMemberMarketplaceMappings?.some(
                (mapping: any) =>
                    mapping.isSellerSide &&
                    mapping.engagementId == engagementId &&
                    mapping.currentSellerTMRole === SELLER_TM_ROLE.LegalCounsel
            )
        );
    };

    const isSellerTeamMemberWithoutCommsHub = () => {
        const perms = getSellerTMCurrentPermissions();
        return (
            perms.length > 0 &&
            !perms.includes(MARKETPLACE_SELLER_TEAM_MEMBER_PERMISSION.CommsHub)
        );
    };

    const isCommsHubReadOnly = () => isSellerTeamMemberWithoutCommsHub() || isObserver;

    const isReadOnly = () => {
        return (
            isObserver ||
            isTeamMemberWithReadonlyAccess() ||
            !isEngagementActive()
        );
    };

    const isSellerProfileReadOnly = () =>
        isReadOnly() &&
        !canAdminEditDuringSuspension(
            party,
            currentEngagement?.engagementProcess?.status
        );

    const isDataAndDocsTabReadOnly = () => {
        const hasPracticeDataAndDocs =
            summary?.roleId == USER_ROLES.PRACTICE_SECONDARY_USER &&
            ((summary?.associateMember ?? []) as any[]).some(
                (am) =>
                    am.associateMemberMarketplaceMappings &&
                    (am.associateMemberMarketplaceMappings as any[]).some(
                        (mapping) =>
                            mapping.isSellerSide &&
                            mapping.engagementId == engagementId &&
                            mapping.currentSellerTMPermissions &&
                            (mapping.currentSellerTMPermissions as any[]).some(
                                (sellerPerm) =>
                                    sellerPerm ==
                                    MARKETPLACE_SELLER_TEAM_MEMBER_PERMISSION.PracticeDataAndDocs
                            )
                    )
            );
        const isSellerEditingDuringSuspension = canSellerEditDuringSuspension(
            party,
            currentEngagement?.engagementProcess?.status,
            currentEngagement?.engagementProcess
                ?.isSellerDaqiEditableDuringSuspension
        );
        if (hasPracticeDataAndDocs) {
            return !isEngagementActive() && !isSellerEditingDuringSuspension;
        }
        return (
            isReadOnly() &&
            !canAdminEditDuringSuspension(
                party,
                currentEngagement?.engagementProcess?.status
            ) &&
            !(isSellerEditingDuringSuspension && !isTeamMemberWithReadonlyAccess())
        );
    };

    const onDisconnect = () => {
        connection?.off('MP_RefreshTimeline');
        connection?.off('MP_RefreshNotificationFlags');
    };

    const logMarketplaceActivity = (request: LogMarketplaceActivityRequest) => {
        if (isViewAsBuyerActive()) {
            return;
        }
        axios
            .post('/api/marketplace/MarketplaceActivityAuditLogs', request)
            .catch(() => {});
    };

    useEffect(() => {
        if (engagementId && !isAdmin && engagementId !== summary?.lastActiveEngagementId) {
            dispatch(UpdateLastActiveEngagement(engagementId));
        }
    }, [engagementId]);

    useEffect(() => {
        dispatch(LoadMarketplacePricing(engagementId));
        return () => {
            onDisconnect();
        };
    }, []);

    const fetchEngagementAndAvailableBuyers = async (
        fetchBuyers: boolean = true,
        noLoader: boolean = true
    ) => {
        if (!noLoader) setIsEngagementLoading(true);
        const timelinePromise = dispatch(
            GetTimelineById({ id: engagementId, isTemplate: false })
        );
        try {
            await Promise.all(
                !fetchBuyers
                    ? [timelinePromise]
                    : [
                          axios
                              .get(
                                  `/api/Marketplace/Engagements/SFAS/${engagementId}/AvailableBuyers`
                              )
                              .then((response) => {
                                  if (response?.status === 200) {
                                      setAvailableBuyers(response.data);
                                  }
                              }),
                          timelinePromise,
                      ]
            );
        } finally {
            setIsEngagementLoading(false);
        }
    };

    const drillStateRef = useRef({ engagementId, isDrilledDown, viewedTimelineId });
    drillStateRef.current = { engagementId, isDrilledDown, viewedTimelineId };

    useEffect(() => {
        if (isConnected) {
            connection.on('MP_RefreshTimeline', () => {
                fetchEngagementAndAvailableBuyers(true, false).then();
                dispatch(RefreshNotificationFlags());
                if (drillStateRef.current.isDrilledDown) {
                    dispatch(
                        GetBuyerTimeline({
                            engagementId: drillStateRef.current.engagementId,
                            timelineId: drillStateRef.current.viewedTimelineId,
                        })
                    );
                }
            });
            connection.on('MP_RefreshNotificationFlags', () => {
                dispatch(RefreshNotificationFlags());
            });
        }
    }, [isConnected]);

    useEffect(() => {
        if (isDrilledDown) {
            dispatch(
                GetBuyerTimeline({ engagementId, timelineId: viewedTimelineId })
            );
        } else {
            dispatch(resetDrilledTimeline());
        }
    }, [isDrilledDown, viewedTimelineId, engagementId, currentEngagement?.id]);

    useEffect(() => {
        if (isDrilledDown || !isWaitingForTheCatchUp(currentEngagement)) {
            setResumeCatchUp(null);
            return;
        }
        dispatch(GetResumeCatchUp(engagementId))
            .unwrap()
            .then(setResumeCatchUp)
            .catch(() => setResumeCatchUp(null));
    }, [isDrilledDown, engagementId, currentEngagement]);

    useEffect(() => {
        if (!isAdmin) {
            setIsPracticeOfCurrentUserAndIsInEngagement(
                summary?.engagements?.some((p: any) => p.id === engagementId)
            );
        }
    }, [summary]);

    useEffect(() => {
        // The store may still hold the previously opened engagement (the list's
        // "Seller Dashboard" button navigates without resetting it, and a failed
        // GetTimelineById keeps the old value). Clear it before loading so a failed
        // load shows the "could not be loaded" state instead of another
        // engagement's data under this URL.
        dispatch(resetCurrentTimeline());
        fetchEngagementAndAvailableBuyers(true, false).then();
        if (engagementId) {
            logMarketplaceActivity({ engagementId, event: MarketplaceActivityEvent.MarketplaceOpened });
        }
    }, [engagementId]);

    const fetchSystemBuyers = () => {
        axios
            .get(`api/Marketplace/MarketplaceBuyers/all/${engagementId}`)
            .then((response) => {
                if (response.status === 200) {
                    setSystemBuyers(response.data);
                }
            })
            .finally(() => {
                setIsSystemBuyersLoading(false);
            });
    };

    useEffect(() => {
        if (isAdmin || isBroker) fetchSystemBuyers();
        else setIsSystemBuyersLoading(false);
    }, []);

    useEffect(() => {
        if (currentEngagement && Array.isArray(currentEngagement.events)) {
            setEvents(currentEngagement.events);
        }

        setEngagementHistoryRefreshTrigger((prev) => !prev);

        if (currentEngagement?.engagementProcess?.sellerProfileId) {
            dispatch(
                SelectProfile(
                    currentEngagement?.engagementProcess?.sellerProfileId
                )
            );
        }
    }, [currentEngagement]);

    useEffect(() => {
        const sellerProfileId =
            currentEngagement?.engagementProcess?.sellerProfileId;
        if (activeTab === SellerMarketplaceTab.SellerProfile && sellerProfileId) {
            dispatch(RefreshProfile(sellerProfileId));
        }
    }, [activeTab, currentEngagement?.engagementProcess?.sellerProfileId]);

    useEffect(() => {
        if (!currentEngagement) {
            return;
        }
        const value = searchParams.get('tab');
        const numberValue = Number(value);
        if (
            value &&
            numberValue &&
            tabComponents.some((tab) => tab.id === numberValue) &&
            shouldShowTab({ id: numberValue })
        ) {
            setActiveTab(numberValue);
            const tabName = SellerMarketplaceTabs.find((t) => t.id === numberValue)?.label;
            if (tabName && engagementId && lastLoggedTabRef.current !== numberValue) {
                lastLoggedTabRef.current = numberValue;
                logMarketplaceActivity({
                    engagementId,
                    event: MarketplaceActivityEvent.TabVisited,
                    tabName,
                });
            }
        } else {
            updateSearchParams({
                tab: (searchParams.get(TIMELINE_QUERY_PARAM)
                    ? SellerMarketplaceTab.EngagementTimeline
                    : 1
                ).toString(),
            });
        }
    }, [searchParams, currentEngagement]);

    const updateSearchParams = (params: { [key: string]: string }) => {
        const newParams: Record<string, string> = {};
        newParams.tab = params.tab ?? activeTab.toString();
        if (params.subtab !== undefined) {
            newParams.subtab = params.subtab;
        }
        if (params.meetingstab !== undefined) {
            newParams.meetingstab = params.meetingstab;
        }
        const buyertab = params.buyertab ?? searchParams.get('buyertab') ?? undefined;
        if (buyertab != null) {
            newParams.buyertab = buyertab;
        }
        const timeline = searchParams.get(TIMELINE_QUERY_PARAM);
        if (timeline != null) {
            newParams[TIMELINE_QUERY_PARAM] = timeline;
        }
        const notEngaged = searchParams.get(NOT_ENGAGED_BUYER_QUERY_PARAM);
        if (notEngaged != null && newParams.tab === SellerMarketplaceTab.EngagementTimeline.toString()) {
            newParams[NOT_ENGAGED_BUYER_QUERY_PARAM] = notEngaged;
        }
        setSearchParams(newParams);
    };

    const backToMasterTimeline = () => {
        const newParams: Record<string, string> = {};
        searchParams.forEach((value, key) => {
            if (key !== TIMELINE_QUERY_PARAM && key !== NOT_ENGAGED_BUYER_QUERY_PARAM) {
                newParams[key] = value;
            }
        });
        setSearchParams(newParams);
    };

    const navigateToDocument = (documentId: string) => {
        setHighlightItemId(documentId);
        navigateToTab(SellerMarketplaceTab.EngagementDocuments);
    };

    const navigateToDocumentSigning = (documentId: string) => {
        setDocumentIdToSign(documentId);
        navigateToDocument(documentId);
    };

    const navigateToProject = (projectId: string) => {
        setHighlightItemId(projectId);
        navigateToTab(SellerMarketplaceTab.DataAndDocs);
    };

    const navigateToBuyers = () => {
        navigateToTab(SellerMarketplaceTab.Buyers);
    };

    const navigateToMeetingScheduling = () => {
        updateSearchParams({
            tab: Number(SellerMarketplaceTab.CommsHub).toString(),
            subtab:
                party !== TimelineParty.Buyer
                    ? Number(MarketplaceCommsHubTab.Meetings).toString()
                    : Number(MarketplaceCommsHubTab.MeetingScheduling).toString(),
            ...(party !== TimelineParty.Buyer && {
                meetingstab: Number(
                    MarketplaceCommsHubMeetingsTab.BuyerMeetingScheduling
                ).toString(),
            }),
        });
    };

    const navigateToClosingDate = () => {
        updateSearchParams({
            tab: Number(SellerMarketplaceTab.CommsHub).toString(),
            subtab: Number(MarketplaceCommsHubTab.ClosingDate).toString(),
        });
    };

    const teaserEvent = currentEngagement?.events.find(
        (event) =>
            event.linkedAction?.actionType ===
            TimelineActionType.SellerTeaserApproval
    );

    // [#1300] While the resume's catch-up has its teaser approval open, the Seller reviews the confirmed teaser again:
    // editable there until they confirm it, once for the whole catch-up. Their own approval stays Completed. A teaser
    // never confirmed is still confirmed on the Seller's own approval, as before.
    const isReviewingTheTeaserAgain =
        !!currentEngagement?.engagementData?.isTeaserConfirmed &&
        !!openTeaserApprovalOf(isOnTheCatchUp ? drilledTimeline : resumeCatchUp);

    // [#1299] On the catch-up the Seller's windows work its steps, for the buyers riding it only.
    const actingTimeline = isOnTheCatchUp ? drilledTimeline : currentEngagement;
    const actingProcess = isOnTheCatchUp
        ? withOnlyTheRiders(
              drilledTimeline.engagementProcess ?? currentEngagement.engagementProcess,
              currentEngagement.engagementProcess?.buyers ?? [],
              ridersOf(drilledTimeline.timelineId, engagementTimelines)
          )
        : withoutTheRiders(currentEngagement?.engagementProcess, engagementTimelines, engagementId);

    const refreshAfterAction = () => {
        fetchEngagementAndAvailableBuyers().then();
        if (isDrilledDown) {
            dispatch(GetBuyerTimeline({ engagementId, timelineId: viewedTimelineId }));
        }
    };

    // [#1299] While the Seller's own timeline waits, its badges and docket rows are the catch-up's - the steps they act on.
    const badgedTimelineId =
        isTheSellersTimelineWaiting && resumeCatchUp?.timelineId ? resumeCatchUp.timelineId : viewedTimelineId;
    const docketEvents = isOnTheCatchUp
        ? drilledTimeline.events
        : isTheSellersTimelineWaiting && resumeCatchUp
          ? resumeCatchUp.events
          : currentEngagement?.events;

    const onDocketRowClick = (eventId: string, timelineId?: number) => {
        if (isTheSellersTimelineWaiting && resumeCatchUp?.timelineId) {
            openTheCatchUp(resumeCatchUp.timelineId);
            return;
        }
        // [#1314] A row of another timeline - a Late Buyer's catch-up, or the Seller's own while a catch-up is open -
        // opens that timeline; a row of the one in view opens its step.
        if (timelineId !== undefined && timelineId !== (viewedTimelineId ?? mainTimelineId)) {
            openTheCatchUp(timelineId);
            return;
        }
        onEventClick(eventId);
    };

    const openTheCatchUp = (catchUpTimelineId: number) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set('tab', SellerMarketplaceTab.EngagementTimeline.toString());
        newParams.set(TIMELINE_QUERY_PARAM, catchUpTimelineId.toString());
        newParams.delete(NOT_ENGAGED_BUYER_QUERY_PARAM);
        setSearchParams(newParams);
    };


    const tabComponents = [
        {
            id: SellerMarketplaceTab.MyEngagement,
            content: () => (
                <MyEngagement
                    fetchData={() => fetchEngagementAndAvailableBuyers().then()}
                    isAdminView={isAdmin}
                    isReadOnly={isReadOnly()}
                    isRestrictedAccess={isObserver || isTeamMemberWithReadonlyAccess()}
                    party={party}
                />
            ),
            notificationFlag: `${NotificationFlagsCategories.MpCode}.${currentEngagement?.id}.${NotificationFlagsCategories.EngagementCode}`,
        },
        {
            id: SellerMarketplaceTab.EngagementDocuments,
            content: () => (
                <SellersEngagementDocuments
                    timelineId={currentEngagement.id}
                    currentEngagement={currentEngagement}
                    documentsToApproveAgain={documentsToApproveAgainOn(
                        isOnTheCatchUp ? drilledTimeline : isTheSellersTimelineWaiting ? resumeCatchUp : undefined
                    )}
                    preSelectedDocumentId={highlightItemId}
                    resetPreSelectedDocumentId={() => setHighlightItemId(null)}
                    isReadOnly={isReadOnly()}
                    documentIdToSign={documentIdToSign}
                    resetDocumentIdToSign={() => setDocumentIdToSign(null)}
                />
            ),
            notificationFlag: `${NotificationFlagsCategories.MpCode}.${currentEngagement?.id}.${NotificationFlagsCategories.EngagementDocumentsCode}`,
        },
        {
            id: SellerMarketplaceTab.EngagementTimeline,
            content: () =>
                isDrilledDown && drilledTimeline?.timelineId !== viewedTimelineId ? (
                    Helpers.renderTableLoader()
                ) : (
                    <EngagementTimeline
                        id={currentEngagement.id}
                        timelineId={viewedTimelineId}
                        events={isDrilledDown ? drilledTimeline.events ?? [] : events}
                        breakMarkers={shownTimeline.breakMarkers}
                        cancelledSteps={shownTimeline.cancelledSteps}
                        startDate={
                            (shownTimeline.engagementProcess ?? currentEngagement.engagementProcess)
                                .startDate
                        }
                        currentDate={
                            (shownTimeline.simulatedNowUtc ?? currentEngagement.simulatedNowUtc)
                                ? DateTimeHelper.parseUtc(
                                      shownTimeline.simulatedNowUtc ?? currentEngagement.simulatedNowUtc
                                  )
                                : undefined
                        }
                        setSearchParams={updateSearchParams}
                        engagementData={shownTimeline.engagementData ?? currentEngagement.engagementData}
                        engagementProcess={
                            shownTimeline.engagementProcess ?? currentEngagement.engagementProcess
                        }
                        onEventClick={onEventClick}
                        tempo={shownTimeline.tempo}
                        levelOfService={currentEngagement.levelOfService}
                        fetchData={() => fetchEngagementAndAvailableBuyers().then()}
                        recalculateEventsBasedOnTempo={
                            recalculateEventsBasedOnTempo
                        }
                        isReadOnly={isReadOnly() || (isDrilledDown && !isOnTheCatchUp)}
                        isBuyerView={false}
                        hideExecuteButton={
                            (isDrilledDown && !isOnTheCatchUp) ||
                            isTheSellersTimelineWaiting ||
                            getSellerTMCurrentPermissions().length > 0
                        }
                        isDrilledView={isDrilledDown}
                        areStepsActionable={isDrilledDown ? isOnTheCatchUp : !isTheSellersTimelineWaiting}
                    />
                ),
            notificationFlag: marketplaceFlagCodes.sellerTimelinePreview({ engagementId: currentEngagement?.id, timelineId: badgedTimelineId }),
        },
        {
            id: SellerMarketplaceTab.Buyers,
            content: () => (
                <EngagementBuyers
                    currentParty={party}
                    engagementTimeline={currentEngagement}
                    fetchData={fetchEngagementAndAvailableBuyers}
                    navigateToDocument={navigateToDocument}
                    availableBuyers={availableBuyers}
                    systemBuyers={systemBuyers || []}
                    resumeCatchUp={resumeCatchUp}
                />
            ),
            notificationFlag: `${NotificationFlagsCategories.MpCode}.${currentEngagement?.id}.${NotificationFlagsCategories.BuyersCode}`,
        },
        {
            id: SellerMarketplaceTab.DeadlineDocket,
            content: () => (
                <DeadlineDocket
                    engagementId={currentEngagement.id}
                    engagementStartDate={
                        currentEngagement.engagementProcess.startDate
                    }
                    engagementData={currentEngagement.engagementData}
                    engagementProcess={currentEngagement.engagementProcess}
                    onEventClick={onDocketRowClick}
                    viewedTimelineId={viewedTimelineId ?? mainTimelineId}
                    events={docketEvents}
                    dataRequestProjects={
                        currentEngagement.engagementData?.dataRequestProjects
                    }
                    isReadonly={isReadOnly()}
                    notificationFlagPrefix={marketplaceFlagCodes.sellerDeadlineDocket({ engagementId: currentEngagement?.id, timelineId: badgedTimelineId })}
                />
            ),
            notificationFlag: marketplaceFlagCodes.sellerDeadlineDocket({ engagementId: currentEngagement?.id, timelineId: badgedTimelineId }),
        },
        {
            id: SellerMarketplaceTab.DataAndDocs,
            content: () => (
                <DataAndDocsTab
                    engagementId={currentEngagement.id}
                    preSelectedProjectId={highlightItemId}
                    resetPreSelectedProjectId={() => setHighlightItemId(null)}
                    isReadOnly={isDataAndDocsTabReadOnly()}
                />
            ),
            notificationFlag: `${NotificationFlagsCategories.MpCode}.${currentEngagement?.id}.${NotificationFlagsCategories.DataAndDocsCode}`,
        },
        {
            id: SellerMarketplaceTab.Settings,
            content: () =>
                isAdmin ? (
                    <MarketplaceSettings
                        isTemplate={false}
                        engagementId={currentEngagement.id}
                        engagementLevelOfService={
                            currentEngagement.levelOfService
                        }
                        isConsiderationReadonly={anyLoiSelected(currentEngagement?.engagementProcess)}
                    />
                ) : (
                    <></>
                ),
        },
        {
            id: SellerMarketplaceTab.CommsHub,
            content: () => (
                <MarketplaceCommsHub
                    engagementId={currentEngagement.id}
                    notificationFlagPrefix={`${NotificationFlagsCategories.MpCode}`}
                    engagement={currentEngagement}
                    meetingsGroupId={currentEngagement.meetingsGroupId}
                    setSearchParams={updateSearchParams}
                    isReadOnly={isCommsHubReadOnly()}
                />
            ),
            notificationFlag: `${NotificationFlagsCategories.MpCode}.${currentEngagement?.id}.${NotificationFlagsCategories.CommsHubCode}`,
        },
        {
            id: SellerMarketplaceTab.EngagementHistory,
            content: () => (
                <EngagementHistoryTable
                    engagementId={currentEngagement.id}
                    events={currentEngagement.events}
                    engagementData={currentEngagement.engagementData}
                    viewParty={party}
                    canNavigateToTransaction={!isAdmin}
                    onEventClick={onEventClick}
                    isReadonly={isReadOnly()}
                    refreshTrigger={engagementHistoryRefreshTrigger}
                    buyers={currentEngagement.engagementProcess?.buyers ?? []}
                    onAdminClickBuyerEvent={onAdminClickBuyerEvent}
                    sellerId={currentEngagement.engagementProcess.userId}
                    advisorCompanyId={
                        currentEngagement.engagementProcess?.advisorCompanyId
                    }
                />
            ),
            notificationFlag: `${NotificationFlagsCategories.MpCode}.${currentEngagement?.id}.${NotificationFlagsCategories.EngagementHistoryCode}`,
        },
        {
            id: SellerMarketplaceTab.SellerProfile,
            content: () => (
                <MarketplaceSellerProfileComponent
                    inReadonly={isSellerProfileReadOnly()}
                />
            ),
            notificationFlag: `${NotificationFlagsCategories.MpCode}.${currentEngagement?.id}.${NotificationFlagsCategories.SellerProfileUpdatedCode}`,
            inReadonly: isSellerProfileReadOnly(),
        },
        {
            id: SellerMarketplaceTab.DataRoomLayout,
            content: () => <EngagementDataRoomHost isReadonly={isReadOnly()} />,
        },
        {
            id: SellerMarketplaceTab.VDRAccess,
            content: () => (
                <VDRAccess
                    currentEngagement={currentEngagement}
                    availableBuyers={availableBuyers}
                />
            ),
        },
        {
            id: SellerMarketplaceTab.Lois,
            content: () => (
                <LoiFormsTab
                    engagementId={currentEngagement.id}
                    events={events}
                    levelOfService={currentEngagement.levelOfService}
                    isAdmin={isAdmin}
                    engagedBuyerId={
                        currentEngagement.engagementProcess?.buyers.find(
                            (b) => b.isLoiSelected
                        )?.buyerId ?? null
                    }
                />
            ),
        },
        {
            id: SellerMarketplaceTab.FAQs,
            content: () => <MarketplaceFaqs isAdmin={false} engagementId={engagementId} />,
        },
        {
            id: SellerMarketplaceTab.LoiComparison,
            content: () => (
                <LoiComparisonTab
                    engagementId={currentEngagement.id}
                    levelOfService={currentEngagement.levelOfService}
                    engagementProcess={currentEngagement.engagementProcess}
                    setSearchParams={updateSearchParams}
                    isSeller={party === TimelineParty.Seller}
                    isBroker={isBroker}
                    isAdmin={isAdmin}
                    loiComparisonEventId={
                        currentEngagement.events.find(
                            (e) => e.linkedAction?.actionType === TimelineActionType.SellerLoiComparison
                        )?.id ?? null
                    }
                    isSelectionFinalized={isLoiSelectionFinalized}
                    fetchData={() => fetchEngagementAndAvailableBuyers().then()}
                />
            ),
        },
        {
            id: SellerMarketplaceTab.FlowOfFunds,
            content: () => (
                <FlowOfFundsTab
                    engagementId={currentEngagement.id}
                    party={party}
                    setSearchParams={updateSearchParams}
                    searchParams={searchParams}
                />
            ),
            notificationFlag: `${NotificationFlagsCategories.MpCode}.${currentEngagement?.id}.${NotificationFlagsCategories.FlowOfFundsCode}`,
        },
    ];

    const activeTabNotificationFlag = tabComponents.find(
        (tab) => tab.id === activeTab
    )?.notificationFlag;

    useClearNotificationFlagsOnLeave(
        (eventCode) =>
            !!activeTabNotificationFlag &&
            eventCode.toLowerCase() === activeTabNotificationFlag.toLowerCase(),
        `${activeTab}|${currentEngagement?.id}`
    );

    const navigateToTab = (tab: SellerMarketplaceTab) => {
        updateSearchParams({
            tab: Number(tab).toString(),
        });
    };

    const recalculateEventsBasedOnTempo = (tempo: TimelineTempo) => {
        const newEvents = TimelineEventSortingService.sortTimelineEvents(
            currentEngagement.events,
            currentEngagement.levelOfService,
            tempo,
            currentEngagement.engagementProcess?.startDate
        );
        setEvents(newEvents);
    };

    const onEventClick = (eventId: string) => {
        if ((isDrilledDown && !isOnTheCatchUp) || isTheSellersTimelineWaiting) {
            return;
        }
        const guid = eventId.replace('event-', '');
        const events = actingTimeline.events;
        const selectedEvent = events.find((x) => x.id == guid);
        if (!selectedEvent?.linkedAction) return;
        const linkedBuyerReviewAction =
            selectedEvent.linkedAction.actionType ===
                TimelineActionType.BuyerReviewDocument &&
            ((!!selectedEvent.linkedAction?.actionReferenceId &&
                !!events.find(
                    (e) =>
                        e.linkedAction &&
                        e.linkedAction?.id ==
                            selectedEvent.linkedAction?.actionReferenceId
                )) ||
                selectedEvent.linkedAction?.referenceItemId);

        if (
            selectedEvent.linkedAction?.actionType ==
            TimelineActionType.SellerCustomSelectLoiAndDdNdaTerms
        ) {
            const engagedBuyer = currentEngagement.engagementProcess?.buyers.find(
                (b) => b.isLoiSelected
            );
            const ddNdaDocument = findBuyerDdNdaDocument(
                selectedEvent.linkedAction,
                currentEngagement.engagementData,
                engagedBuyer?.buyerId
            );
            const actionState = engagedBuyer?.actionState.find(
                (a) => a.actionId == selectedEvent.linkedAction?.id
            );
            const isSellerSigner = party === TimelineParty.Seller;
            if (ddNdaDocument && isDdNdaDocumentSignedByBuyer(ddNdaDocument)) {
                if (
                    isSellerSigner &&
                    ddNdaDocument.status === DocumentDetailsStatus.RequiresAction
                ) {
                    navigateToDocumentSigning(ddNdaDocument.id);
                } else {
                    navigateToDocument(ddNdaDocument.id);
                }
            } else if (actionState?.documentDetailsId) {
                const loiDocument =
                    currentEngagement.engagementData.documentsList.find(
                        (d) => d.id === actionState.documentDetailsId
                    );
                const isLoiAwaitingSellerSignature =
                    loiDocument?.type === ActionDocumentType.ForSign &&
                    loiDocument.status === DocumentDetailsStatus.RequiresAction &&
                    loiDocument.counterParty !== TimelineParty.Buyer;
                if (isSellerSigner && isLoiAwaitingSellerSignature) {
                    navigateToDocumentSigning(loiDocument.id);
                } else {
                    navigateToDocument(actionState.documentDetailsId);
                }
            } else if (isAdmin) {
                navigateToTab(SellerMarketplaceTab.Lois);
            } else {
                navigateToTab(SellerMarketplaceTab.EngagementDocuments);
            }
        } else if (
            BuyerSelectionOptionsList.some((option) => {
                return option.value === selectedEvent.linkedAction?.actionType;
            })
        ) {
            setActiveEventId(selectedEvent.id);
            setIsBuyerSelectionPopupVisible(true);
        } else if (
            NdaTermSelectionOptionsList.some((option) => {
                return option.value === selectedEvent.linkedAction?.actionType;
            })
        ) {
            setActiveEventId(selectedEvent.id);
            setIsNdaTermPopupVisible(true);
        } else if (
            TimelineActionType.SellerEngagementDocument ===
                selectedEvent.linkedAction?.actionType ||
            linkedBuyerReviewAction
        ) {
            navigateToDocument(selectedEvent.linkedAction.referenceItemId);
        } else if (
            selectedEvent.linkedAction?.actionType ==
            TimelineActionType.SellerTeaserApproval
        ) {
            setIsTeaserInfoModalVisible(true);
        } else if (
            selectedEvent.linkedAction?.actionType ==
            TimelineActionType.SellerDataAndDocumentRequest
        ) {
            navigateToProject(selectedEvent.linkedAction.referenceItemId);
        } else if (
            selectedEvent.linkedAction?.actionType ==
            TimelineActionType.VetValueBuyerSelectionAndTeaserPosting
        ) {
            navigateToBuyers();
        } else if (
            selectedEvent.linkedAction?.actionType ==
            TimelineActionType.SellerProvideMeetingAvailability
        ) {
            navigateToMeetingScheduling();
        } else if (
            selectedEvent.linkedAction?.actionType ==
            TimelineActionType.SellerBuyerMeetings
        ) {
            navigateToMeetingScheduling();
        } else if (
            selectedEvent.linkedAction?.actionType ==
            TimelineActionType.SellerProfile
        ) {
            navigateToTab(SellerMarketplaceTab.SellerProfile);
        } else if (
            selectedEvent.linkedAction?.actionType ==
            TimelineActionType.SellerLoiComparison
        ) {
            navigateToTab(SellerMarketplaceTab.LoiComparison);
        } else if (
            selectedEvent.linkedAction?.actionType ==
            TimelineActionType.SellerBuyerAgreeOnClosingDate
        ) {
            navigateToClosingDate();
        } else if (
            selectedEvent.linkedAction?.actionType ==
            TimelineActionType.SellerBuyerFlowOfFunds
        ) {
            navigateToTab(SellerMarketplaceTab.FlowOfFunds);
        }
    };

    const onAdminClickBuyerEvent = (eventId: string, buyerId: number) => {
        const events = currentEngagement.events;
        const targetEvent = events.find((x) => x.id == eventId);

        const targetBuyer = currentEngagement.engagementProcess?.buyers.find(
            (b) => b.buyerId === buyerId
        );
        const targetActionState = targetBuyer?.actionState.find(
            (f) => f.actionId === targetEvent.linkedAction?.id
        );

        switch (targetEvent.linkedAction?.actionType) {
            case TimelineActionType.SellerBuyerSelectionIdNda:
            case TimelineActionType.SellerCustomSelectDataNdaTerms:
            case TimelineActionType.BuyerUploadDocument:
            case TimelineActionType.BuyerDocumentExecution:
                const targetBuyerDocumentId =
                    targetActionState?.documentDetailsId;
                if (targetBuyerDocumentId) {
                    navigateToDocument(targetBuyerDocumentId);
                }
                return;
            case TimelineActionType.BuyerExpressionOfInterestWithRange:
                if (targetActionState) {
                    setBuyerValueRangeInterest({
                        minValue: targetActionState?.minPrice ?? 0,
                        maxValue: targetActionState?.maxPrice ?? 0,
                    });
                    setIsRangeOfValueVisible(true);
                }
                return;
            case TimelineActionType.BuyerReviewDocument:
                let targetReviewDocumentId =
                    targetEvent.linkedAction?.referenceItemId;
                if (targetEvent.linkedAction?.actionReferenceId) {
                    const targetReferenceEvent = events.find(
                        (e) =>
                            e.linkedAction?.id ===
                            targetEvent.linkedAction?.actionReferenceId
                    );
                    targetReviewDocumentId =
                        targetReferenceEvent.linkedAction?.referenceItemId;
                }

                if (targetReviewDocumentId) {
                    navigateToDocument(targetReviewDocumentId);
                }

                return;
        }
    };

    const renderTabContent = () => {
        const activeTabData = tabComponents.find((tab) => tab.id === activeTab);
        return activeTabData ? activeTabData.content() : <></>;
    };

    const getTabNotificationFlag = (tab: number) => {
        const targetCode = tabComponents.find((t) => t.id === tab);
        return targetCode ? (
            <>
                <NotificationFlag
                    flagClassName="notification-flag-wrapper"
                    eventCode={targetCode.notificationFlag}
                    includePrefix={true}
                    doNotRemove={true}
                />
            </>
        ) : (
            <></>
        );
    };

    const getDrilledBuyer = () =>
        currentEngagement?.engagementProcess?.buyers?.find(
            (b) => b.buyerId === drilledTimeline?.buyerId
        );

    // [#1315 F6] The Seller's selections on the main tell the buyers riding a catch-up apart by the engagement's
    // summaries, so they are loaded with the engagement, not only on the drill-down into a catch-up.
    useEffect(() => {
        const hasTheDrilledCatchUp = engagementTimelines.some(
            (summary) => summary.timelineId === drilledTimeline?.timelineId
        );
        const hasThisEngagementsMain = engagementTimelines.some(
            (summary) => summary.kind === TimelineKind.MAIN && summary.timelineId === engagementId
        );
        if ((isDrilledIntoACatchUp && !hasTheDrilledCatchUp) || (!!currentEngagement && !hasThisEngagementsMain)) {
            dispatch(GetEngagementTimelines(engagementId));
        }
    }, [isDrilledIntoACatchUp, drilledTimeline?.timelineId, engagementId, currentEngagement?.id]);

    const getCatchUpTitle = () => {
        const catchUpName = formatCatchUpName(
            catchUpOrdinalOf(drilledTimeline.timelineId, engagementTimelines)
        );
        const riderNames = ridersOf(drilledTimeline.timelineId, engagementTimelines)
            .map((buyerId) =>
                currentEngagement?.engagementProcess?.buyers?.find((b) => b.buyerId === buyerId)
            )
            .filter((buyer) => !!buyer)
            .map((buyer) => formatBuyerDisplayName(buyer.companyName, buyer.buyerAcronym));
        return riderNames.length ? `${catchUpName}: ${riderNames.join(', ')}` : catchUpName;
    };

    const getDrilledTimelineTitle = () => {
        if (isDrilledIntoACatchUp) {
            return getCatchUpTitle();
        }
        const buyer = getDrilledBuyer();
        if (drilledTimeline?.buyerId && buyer) {
            return `${formatBuyerDisplayName(buyer.companyName, buyer.buyerAcronym)}'s timeline`;
        }
        if (isTheResumeCatchUp(drilledTimeline)) {
            return 'The catch-up';
        }
        return `Timeline ${viewedTimelineId}`;
    };

    const getNotEngagedBuyer = () => {
        if (isDrilledDown) return undefined;
        const notEngagedBuyerParam = searchParams.get(NOT_ENGAGED_BUYER_QUERY_PARAM);
        const notEngagedBuyerId = notEngagedBuyerParam ? Number(notEngagedBuyerParam) : NaN;
        if (!Number.isInteger(notEngagedBuyerId)) return undefined;
        return currentEngagement?.engagementProcess?.buyers?.find(
            (b) => b.buyerId === notEngagedBuyerId
        );
    };

    const renderCatchUpBanner = () => {
        if (!isTheSellersTimelineWaiting) {
            return <></>;
        }
        return (
            <CatchUpBanner
                catchUp={resumeCatchUp}
                isReviewingTheTeaserAgain={isReviewingTheTeaserAgain}
                onReviewTeaser={() => setIsTeaserInfoModalVisible(true)}
                onOpenTheCatchUp={openTheCatchUp}
            />
        );
    };

    const renderDrilledTimelineBanner = () => {
        if (activeTab !== SellerMarketplaceTab.EngagementTimeline) {
            return <></>;
        }
        const notEngagedBuyer = getNotEngagedBuyer();
        if (!isDrilledDown && !notEngagedBuyer) {
            return <></>;
        }
        const drilledBuyer = getDrilledBuyer();
        return (
            <>
                {isDrilledDown && (
                    <div className="drilled-timeline-header">
                        <h5>{getDrilledTimelineTitle()}</h5>
                        <div className="drilled-timeline-header-actions">
                            {isAdmin && (
                                <Button
                                    color="link"
                                    className="edit-timeline-btn p-0"
                                    onClick={() =>
                                        navigate(
                                            `/marketplace/admin/engagements/${engagementId}/timelines/${viewedTimelineId}`
                                        )
                                    }>
                                    Edit timeline
                                </Button>
                            )}
                            <Button
                                color="link"
                                className="back-to-master-timeline-btn p-0"
                                onClick={backToMasterTimeline}>
                                Back to the master timeline
                            </Button>
                        </div>
                    </div>
                )}
                {isOnTheCatchUp && isALateBuyersCatchUp && (
                    <Alert color="info" className="drilled-timeline-banner">
                        A Late Buyer&apos;s catch-up: a step waiting for you here is done for this buyer only.
                        Your own timeline runs on as before.
                    </Alert>
                )}
                {isOnTheCatchUp && !isALateBuyersCatchUp && (
                    <Alert color="info" className="drilled-timeline-banner">
                        The resume&apos;s catch-up: a step waiting for you here is done once for every buyer riding it.
                        Your own timeline stays where it stopped until the catch-up reaches it.
                    </Alert>
                )}
                {isDrilledDown && drilledTimeline?.state === TimelineState.SUSPENDED && (
                    <Alert color="warning" className="drilled-timeline-banner">
                        This timeline is frozen: nothing moves on it until the buyer&apos;s
                        participation resumes.
                    </Alert>
                )}
                {isDrilledDown && drilledBuyer && drilledBuyer.isActive === false && (
                    <Alert color="warning" className="drilled-timeline-banner">
                        {formatBuyerDisplayName(drilledBuyer.companyName, drilledBuyer.buyerAcronym)} left the
                        engagement{drilledBuyer.rejectionReason ? `: ${drilledBuyer.rejectionReason}` : ""}. This
                        timeline no longer moves.
                    </Alert>
                )}
                {notEngagedBuyer && (
                    <Alert color="info" className="drilled-timeline-banner" toggle={backToMasterTimeline}>
                        {formatBuyerDisplayName(
                            notEngagedBuyer.companyName,
                            notEngagedBuyer.buyerAcronym
                        )}{' '}
                        {notEngagedBuyer.isActive === false
                            ? "is no longer active in the engagement and has no timeline to show; this is the master timeline."
                            : "has not engaged yet, so they have no timeline of their own; this is the master timeline."}
                    </Alert>
                )}
            </>
        );
    };

    const renderTabs = () => {
        const visibleTabs = SellerMarketplaceTabs.filter((x) =>
            shouldShowTab(x)
        );
        return (
            <Card
                className={`main-card gantt-chart-container marketplace-dynamic-container`}>
                <div className="body_white_box practice-page-tabs m-0 gantt-chart-container marketplace-dynamic-container">
                    <div className="body_inner_content gantt-chart-container marketplace-dynamic-container">
                        <div className="RRT__container">
                            <div className="RRT__tabs body-tabs marketplace-dashboard-tabs">
                                {visibleTabs.map((item, index) => {
                                    return (
                                        <div
                                            key={item.id}
                                            className={`${
                                                activeTab === item.id
                                                    ? 'RRT__tab RRT__tab--first RRT__tab--selected'
                                                    : 'RRT__tab'
                                            }${groupDividerClass(
                                                visibleTabs,
                                                index
                                            )}`}
                                            data-tooltip-id="seller-tab-tooltip"
                                            data-tooltip-content={item.tooltip}
                                            onClick={() => {
                                                setActiveTab(item.id);
                                                updateSearchParams({
                                                    tab: item.id.toString(),
                                                });
                                                dispatch(
                                                    RefreshNotificationFlags()
                                                );
                                            }}>
                                            {toTwoLineTabLabel(item.label)}
                                            {getTabNotificationFlag(item.id)}
                                        </div>
                                    );
                                })}
                            </div>
                            {createPortal(
                                <Tooltip
                                    id="seller-tab-tooltip"
                                    place="bottom"
                                    className="portal-tooltip tooltip-content"
                                />,
                                document.body
                            )}
                        </div>
                        {renderCatchUpBanner()}
                        {renderDrilledTimelineBanner()}
                        {renderTabContent()}
                    </div>
                </div>
            </Card>
        );
    };

    // Admins are not gated by practice membership, so a failed engagement
    // request used to render every tab against an undefined engagement.
    const renderEngagementLoadFailed = () => (
        <Card className="card-section main-card mb-2">
            <div className="p-4 text-center">
                <p className="mb-3">
                    The engagement could not be loaded. Please try again.
                </p>
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() =>
                        fetchEngagementAndAvailableBuyers(true, false).then()
                    }>
                    Try again
                </button>
            </div>
        </Card>
    );

    const renderConnectMarketplaceDashboardPage = () => {
        const fteDvms = currentEngagement?.engagementProcess?.startFteDvm || 0;
        return (
            <div
                className={`marketplace-dynamic-container ${
                    activeTab === SellerMarketplaceTab.EngagementTimeline
                        ? 'marketplace-dashboard-adapt-timeline-preview'
                        : ''
                }`}>
                {isEngagementLoading || isSystemBuyersLoading ? (
                    Helpers.renderPageLoader()
                ) : isAdmin && !currentEngagement ? (
                    renderEngagementLoadFailed()
                ) : currentEngagement &&
                  (isAdmin ||
                      isPracticeOfCurrentUserAndIsInEngagement ||
                      getSellerTMCurrentPermissions().length > 0) ? (
                    <>
                        <div className="main-title-content">
                            <div className="title-breadcrumb">
                                {!isAdmin ? (
                                    <div className="page-title">
                                        <div>
                                            <h3>
                                                Connect Marketplace Dashboard
                                            </h3>
                                            <Breadcrumb>
                                                <BreadcrumbItem>
                                                    <HomeButton />
                                                </BreadcrumbItem>
                                                <BreadcrumbItem active>
                                                    Connect Marketplace
                                                </BreadcrumbItem>
                                            </Breadcrumb>
                                        </div>
                                        <div className="vvconnect-logo">
                                            <img
                                                width={165}
                                                alt="VVConnect"
                                                src={vvConnectLogo}
                                            />
                                        </div>
                                        <div className="buttons-wrapper">
                                            <ContactSupportButton
                                                supportContext={
                                                    SupportContextEnum.Marketplace
                                                }
                                                buttonType="reference"
                                                buttonText="Contact Administrator"
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <div className="page-title">
                                            <h3>
                                                Seller Marketplace Dashboard
                                            </h3>
                                        </div>
                                        <Breadcrumb>
                                            <BreadcrumbItem>
                                                <HomeButton />
                                            </BreadcrumbItem>
                                            <BreadcrumbItem>
                                                <a
                                                    className="breadcrumb-link"
                                                    onClick={() =>
                                                        navigate(
                                                            paths.admin.marketplace
                                                        )
                                                    }>
                                                    Marketplace Admin Home
                                                </a>
                                            </BreadcrumbItem>
                                            <BreadcrumbItem active>
                                                Seller Marketplace
                                            </BreadcrumbItem>
                                        </Breadcrumb>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="gantt-chart-container marketplace-dynamic-container">
                            {renderTabs()}
                        </div>
                    </>
                ) : (
                    <NoPageAccessAlert />
                )}

                {isNdaTermPopupVisible && (
                    <NdaTermsPopup
                        isVisible={isNdaTermPopupVisible}
                        engagementData={actingTimeline.engagementData ?? currentEngagement.engagementData}
                        engagementProcess={actingProcess}
                        engagementId={currentEngagement.id}
                        events={actingTimeline.events}
                        fetchData={refreshAfterAction}
                        activeEventId={activeEventId}
                        setIsVisible={setIsNdaTermPopupVisible}
                        levelOfService={currentEngagement.levelOfService}
                        sellersOwnProcess={isOnTheCatchUp ? currentEngagement.engagementProcess : undefined}
                    />
                )}

                {isBuyerSelectionPopupVisible && (
                    <BuyerSelectionPopup
                        isAdminView={isAdmin || isBroker || isObserver}
                        isReadOnly={isReadOnly()}
                        isVisible={isBuyerSelectionPopupVisible}
                        engagementData={actingTimeline.engagementData ?? currentEngagement.engagementData}
                        engagementProcess={actingProcess}
                        engagementId={currentEngagement.id}
                        events={actingTimeline.events}
                        fetchData={refreshAfterAction}
                        activeEventId={activeEventId}
                        setIsVisible={setIsBuyerSelectionPopupVisible}
                        fteDvms={fteDvms}
                        levelOfService={currentEngagement.levelOfService}
                        sellersOwnTimeline={isOnTheCatchUp ? currentEngagement : undefined}
                    />
                )}

                {isTeaserInfoModalVisible && (
                    <TeaserInfoModal
                        isReadOnly={
                            isReadOnly() ||
                            (!isReviewingTheTeaserAgain &&
                                (currentEngagement?.engagementData
                                    .isTeaserConfirmed ||
                                    teaserEvent?.status ===
                                        TimelineEventStatus.Completed)) ||
                            currentEngagement?.engagementProcess?.status ===
                                EngagementProcessStatus.Completed
                        }
                        isVisible={isTeaserInfoModalVisible}
                        onClose={() => setIsTeaserInfoModalVisible(false)}
                        timelineId={currentEngagement.id}
                        catchUpTimelineId={isOnTheCatchUp ? viewedTimelineId : undefined}
                        teaserData={currentEngagement.engagementData.teaserData}
                        fetchData={refreshAfterAction}
                    />
                )}

                {isRangeOfValueVisible ? (
                    <ValueRangeModal
                        isRangeOfValueVisible={isRangeOfValueVisible}
                        onClose={() => setIsRangeOfValueVisible(false)}
                        onRangeOfValueConfirm={() => {}}
                        selectedEventId={''}
                        isRangeOfValueReadonly={true}
                        minValue={buyerValueRangeInterest.minValue}
                        maxValue={buyerValueRangeInterest.maxValue}
                        isPreviewModeActive={true}
                    />
                ) : (
                    <></>
                )}
            </div>
        );
    };

    const isDeadlineDocketVisible = (tab: any) => {
        return (
            isAdmin ||
            tab.id !== SellerMarketplaceTab.DeadlineDocket ||
            currentEngagement?.engagementProcess?.status !==
                EngagementProcessStatus.Suspended
        );
    };

    const isTabVisibleForTerminatedStatus = (tab: any) => {
        return (
            currentEngagement?.engagementProcess?.status !==
                EngagementProcessStatus.Terminated ||
            tab.id === SellerMarketplaceTab.MyEngagement ||
            tab.id === SellerMarketplaceTab.EngagementDocuments
        );
    };

    const isCommsHubVisible = (tab: any) => {
        return (
            tab.id !== SellerMarketplaceTab.CommsHub ||
            getMarketplaceCommsHubTabs(
                party,
                currentEngagement?.levelOfService,
                currentEngagement?.engagementProcess?.buyers?.some(
                    (b) => b.isDataNdaSigned && b.isActive
                ) ?? false,
                !!currentEngagement?.engagementProcess?.broker
                    ?.brokerChatId &&
                    currentEngagement.engagementProcess.broker.isActive,
                currentEngagement?.events ?? [],
                hasMeetingsOrClips,
                party === TimelineParty.VetValue ||
                    party === TimelineParty.Broker,
                false,
                undefined,
                currentEngagement?.engagementProcess?.buyers?.some(
                    (b) => !!b.buyerCommsId
                )
            ).length > 0
        );
    };

    const isSettingsVisible = (tab: any) => {
        return tab.id !== SellerMarketplaceTab.Settings || isAdmin;
    };

    const isSellerProfileVisible = (tab: any) => {
        return true;
    };

    const isVDRAccessVisible = (tab: any) => {
        return tab.id !== SellerMarketplaceTab.VDRAccess || isAdmin;
    };
    const isDataRoomVisible = (tab: any) => {
        return true;
    };

    const isFaqsVisible = (tab: any) => {
        if (tab.id !== SellerMarketplaceTab.FAQs) return true;
        return (
            party === TimelineParty.Seller ||
            party === TimelineParty.Broker ||
            party === TimelineParty.VetValue
        );
    };

    const isLoisVisible = (tab: any) => {
        if (tab.id !== SellerMarketplaceTab.Lois) return true;
        if (!isAdmin) return false;
        const loiEvent = currentEngagement?.events?.find(
            (e) => e.linkedAction?.actionType === TimelineActionType.BuyerLoiSubmission
        );
        return !!loiEvent && loiEvent.status !== TimelineEventStatus.Upcoming;
    };

    const isLoiComparisonVisible = (tab: any) => {
        if (tab.id !== SellerMarketplaceTab.LoiComparison) return true;
        const loiComparisonEvent = currentEngagement?.events?.find(
            (e) => e.linkedAction?.actionType === TimelineActionType.SellerLoiComparison
        );
        return !!loiComparisonEvent && loiComparisonEvent.status !== TimelineEventStatus.Upcoming;
    };

    const isTabVisibleForSellerTM = (tab: any) => {
        if (party === TimelineParty.VetValue || party === TimelineParty.Broker)
            return true;
        if (currentEngagement?.engagementProcess?.userId === currentUser?.id)
            return true;
        const perms = getSellerTMCurrentPermissions();
        if (perms.length === 0) return true;
        if (
            perms.includes(
                MARKETPLACE_SELLER_TEAM_MEMBER_PERMISSION.FullReadOnlyMarketplace
            )
        )
            return true;
        if (tab.id === SellerMarketplaceTab.MyEngagement) return true;
        if (tab.id === SellerMarketplaceTab.DataAndDocs)
            return perms.includes(
                MARKETPLACE_SELLER_TEAM_MEMBER_PERMISSION.PracticeDataAndDocs
            );
        if (tab.id === SellerMarketplaceTab.CommsHub)
            return perms.includes(
                MARKETPLACE_SELLER_TEAM_MEMBER_PERMISSION.CommsHub
            );
        if (tab.id === SellerMarketplaceTab.DataRoomLayout)
            return perms.includes(
                MARKETPLACE_SELLER_TEAM_MEMBER_PERMISSION.DataRoom
            );
        if (tab.id === SellerMarketplaceTab.FlowOfFunds)
            return isSellerTMLegalCounsel();
        return false;
    };

    const isFlowOfFundsVisible = (tab: any) => {
        if (tab.id !== SellerMarketplaceTab.FlowOfFunds) return true;
        return isFlowOfFundsAvailable(currentEngagement?.engagementProcess);
    };

    const shouldShowTab = (tab: any) => {
        return (
            isDeadlineDocketVisible(tab) &&
            isTabVisibleForTerminatedStatus(tab) &&
            isCommsHubVisible(tab) &&
            isSettingsVisible(tab) &&
            isSellerProfileVisible(tab) &&
            isVDRAccessVisible(tab) &&
            isDataRoomVisible(tab) &&
            isLoisVisible(tab) &&
            isFaqsVisible(tab) &&
            isLoiComparisonVisible(tab) &&
            isFlowOfFundsVisible(tab) &&
            isTabVisibleForSellerTM(tab)
        );
    };

    return (
        <Layout>
            <div
                className={`connect-marketplace-dashboard ${
                    activeTab === SellerMarketplaceTab.CommsHub
                        ? ' marketplace-comms-hub-container'
                        : 'marketplace-tab-container'
                }`}>
                {renderConnectMarketplaceDashboardPage()}
            </div>
            {!isAdmin &&
                !isBroker &&
                !isTeamMemberWithReadonlyAccess() &&
                currentEngagement && (
                    <PaymentValidator
                        fetchEngagement={() =>
                            fetchEngagementAndAvailableBuyers(false).then()
                        }
                    />
                )}
        </Layout>
    );
};

export default ConnectMarketplaceDashboard;
